import { type Component, type ComponentProps, mount } from 'svelte'
import AppLayout, { type AppLayoutProps } from '#components/app_layout.svelte'

export let appLayout: ReturnType<typeof mount> & {
  // showChildComponent: typeof showChildComponent
  // Overriding showChildComponent type to ignore the TS2345 errors it produces on the consumers' side
  showChildComponent: (regionName: RegionName, component: unknown, options?: { props?: ComponentProps<Component> }) => void
  removeCurrentComponent: typeof removeCurrentComponent
}

export interface RegionComponent {
  component: Component
  props?: ComponentProps<Component>
}

export type RegionName = 'main' | 'modal' | 'svelteModal'

const appLayoutProps: AppLayoutProps = $state({})

export function initAppLayout () {
  const target = document.getElementById('app') as HTMLElement
  // Remove spinner
  target!.innerHTML = ''
  // @ts-ignore TS2322 error in strict mode
  appLayout = Object.assign(mount(AppLayout, { target, props: appLayoutProps }), {
    showChildComponent,
    removeCurrentComponent,
  })
  return appLayout
}

function showChildComponent <T extends Component> (regionName: RegionName, component: T, options: { props?: ComponentProps<T> } = {}) {
  const props = 'props' in options ? options.props : {}
  if (component != null) {
    appLayoutProps[regionName] = { component, props }
  } else {
    delete appLayoutProps[regionName]
  }
}

function removeCurrentComponent (regionName: RegionName) {
  delete appLayoutProps[regionName]
}
